export default function Go_Syllabus() {
  return (
    <div>
      <h1>Go_Syllabus </h1>
      <p>Go Syllabus</p>
    </div>
  );
}
